<template>
  <article class="col-xs-12 col-sm-6 col-md-4" v-on:click='navToProviderProfile'>
    <div class="panel lead" style="height: 700px;">
      <figure class="figure">
        <img
          style="height:283px"
          :src="provider.logo" alt="" />
      </figure>
      <figcaption class="figcaption" style="height: 190px;">
        <h3
          class="sec-title"
        >
            {{provider.name}} <br><br v-if="provider.name.length<31">
        </h3>
        <p>
          <strong class="website-name email-address">
            {{ emailAddress }}
          </strong> <br>
          <span class="capital-type">
            {{ providerTypesString }}
          </span>
        </p>
      </figcaption>
      <p><div class="text"><span class="text-concat">{{shortDesc}}</span></div></p>
      <ul class="row compact mb-15 tags">
        <li v-for="capitalType in capitalTypeList.filter((t,i)=>i<2)" class="col-xs-6 col-sm-6">
          <span class="tag-item">{{capitalType}}</span>
        </li>
      </ul>
      <p class="mb-0"><a><i class="text-icon-arrow-right">&rarr;</i> Learn More</a></p>
    </div>
  </article>
</template>

<script>
import slugify from "slugify";
import helper from "../../helper.js";

export default {
  name: 'result-card',
  props: ['provider'],
  computed: {
    emailAddress: function(){
      const maxChar = 28
      if(this.provider.url.length < maxChar) return this.provider.url
      return this.provider.url.substring(0, maxChar-3) + '...'
    },
    shortDesc: function() {
      return `${this.formatDesc(
        this.provider.description.replace().substring(0, 100)
      )}...`;
    },
    longDesc: function() {
      return `${this.formatDesc(this.provider.description)}`;
    },
    providerTypesString: function() {
      if (this.provider.provider_provider_types == null) return "";
      var providerTypes = this.provider.provider_provider_types
        .filter(providerType => {
          return providerType.provider_type != null;
        })
        .map(providerType => {
          return providerType.provider_type.name;
        });
      if (providerTypes.length > 1) {
        var last = providerTypes.pop();
        providerTypes = `${providerTypes.join(", ")} & ${last}`;
        return providerTypes;
      } else {
        return providerTypes[0];
      }
    },
    capitalTypeList: function() {
      if (this.provider.provider_capital_types == null) return [];
      var capitalTypes = this.provider.provider_capital_types
        .filter(capitalType => {
          return capitalType.capital_type != null;
        })
        .map(capitalType => {
          return capitalType.capital_type.name;
        });
      return capitalTypes;
    }
  },
  methods: {
    formatDesc(str) {
      return helper.formatDesc(str);
    },
    navToProviderProfile() {
      if (this.provider.hasOwnProperty("name")) {
        var urlParam = slugify(this.provider.name, { lower: true });
        this.$router.push({
          name: "Profile",
          params: { providerName: urlParam }
        });
      }
    },
  }
}
</script>

<style scoped>
.text {
  position: relative;
  color: black;
}

.text-concat {
  position: relative;
  display: inline-block;
  overflow: hidden;
  max-height: 3.6em; /* (Number of lines you want visible) * (line-height) */
  line-height: 1.2em;
}

.email-address {
  position: relative;
  display: inline-block;
  overflow: hidden;
  max-height: 1.2em; /* (Number of lines you want visible) * (line-height) */
  line-height: 1.2em;
}

</style>



// WEBPACK FOOTER //
// src/elements/results/ResultCard.vue